import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">

        {/* Glow orbs */}
        <div className="glow glow-1"></div>
        <div className="glow glow-2"></div>
        <div className="glow glow-3"></div>

        <div className="overlay">
          <div className="intro-split">

            {/* LEFT — Image */}
            <div className="split-image">
              <img
  src="img/banner38.png"
  alt="Gurunathan Electronics"
  className="hero-img"
  loading="eager"
  fetchpriority="high"
/>
            </div>

            {/* RIGHT — Content */}
            <div className="split-content">
              <div className="god-names">
                🙏 ஸ்ரீ உச்சினி மாகாளியம்மன் துணை
                <span>·</span>
                ஸ்ரீ அக்கினி வீரபத்திரன்சாமி துணை
                <span>·</span>
                ஸ்ரீ லாடசன்னாசி துணை
              </div>

              <div className="offer-badge">
                <span className="offer-icon">⚡</span>
                <span className="offer-text">
                  இப்போது சிறப்பு சலுகை — Up to{" "}
                  <strong>50% OFF</strong> — Limited Stock!
                </span>
              </div>

              <h1>
                <span className="welcome-text">Welcome to</span>
               <span className="brand-text">குருநாதன் எலக்ட்ரான்னிக்ஸ்</span>
<a
  href="https://maps.app.goo.gl/5vThNWSi47fcPxUg8"
  target="_blank"
  rel="noopener noreferrer"
  className="brand-location"
>
  <i className="fa fa-map-marker"></i> பேரையூர்
</a>
              </h1>

              <p className="tagline">தரம் ⚡ நம்பிக்கை ⚡ சேவை</p>

              <p>
                {props.data
                  ? props.data.paragraph
                  : "உங்கள் இல்லம் மற்றும் தொழிலுக்குத் தேவையான மின்னணு சாதனங்களின் முழுமையான சந்தை — Peraiyur, Madurai."}
              </p>

              <div className="hero-buttons">
                <a href="tel:+919042011186" className="btn btn-custom btn-lg">
                Contact Us
               </a>
                <a href="#products" className="btn btn-outline btn-lg page-scroll">
                  Our Products
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
};